import ReactDOM from 'react-dom';
import NS1PriceEstimatorNew from './components/NS1PriceEstimatorNew';
import NS1PriceEstimator from './components/NS1PriceEstimator';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './NS1PE.widget';
import { RenderFn } from 'src/types/widgets';
import 'carbon-components/css/carbon-components.min.css';
import { Provider } from 'react-redux';
import store from './lib/redux/store';
import { TranslationProvider } from '../../common/components/TranslationProvider/TranslationProvider';

interface Ns1PeProps {
  useVersion2: string;
}

function refineInputTypes(input: Record<string, unknown>): Ns1PeProps {
  //this is taking the config param and returning it for use within the widget.
  return {
    useVersion2: String(input.useVersion2 || ''),
  };
}

const render: RenderFn = async function (instanceId, langCode, _origin, cb) {
  const { element, locale, messages, params } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
    refineInputTypes,
  );
  if (!element || !locale || !messages) {
    return;
  }
  const localeCode = element.getAttribute('data-localecode') || 'en-us';

  const renderNewWidget =
    params.useVersion2.trim().toLowerCase() === 'yes' ||
    params.useVersion2.trim().toLowerCase() === 'true';

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider locale="en" defaultLocale="en">
        <TranslationProvider messages={messages}>
          {renderNewWidget ? (
            <NS1PriceEstimatorNew
              langCode={localeCode}
              test={false}
              countryToTest={'us'}
              useVersion2={params.useVersion2}
            />
          ) : (
            <NS1PriceEstimator
              langCode={localeCode}
              test={false}
              countryToTest={'us'}
              useVersion2={params.useVersion2}
            />
          )}
        </TranslationProvider>
      </IntlProvider>
    </Provider>,
    element,
    () => cb(element),
  );
};

export default render;
